import { Component, OnInit } from '@angular/core';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { AppEventService } from '../events.service';
import { ActivatedRoute } from '@angular/router';
import { IHeroEventListResolverData } from './hero-event-list-models/hero-event-list-resolver-data.interface';
import {
  HeroEventListResponseDto,
  IDisplayData,
  PaginationResultsDto
} from '@whetstoneeducation/hero-common';
import { IHeroEventListFilter } from './hero-event-list-models/hero-event-list-filter.interface';
import { BaseComponent } from '../../../shared/base-classes/base.component';
import { TableFilterOptions } from '../../../shared/tables/table-filters/table-filters';
import { TableFiltersPageKeyEnum } from '../../../shared/tables/table-filters/table-filters-page-key.enum';
import { ITableFilters } from '../../../shared/tables/table-filters/table-filters.interface';

@Component({
  selector: 'app-events-list',
  templateUrl: './hero-events-list.component.html',
  styleUrls: ['./hero-events-list.component.scss']
})
export class AppEventsListComponent extends BaseComponent implements OnInit {
  public heroEvents: HeroEventListResponseDto[];
  public eventCategoryOptions: IDisplayData[];
  public filters: IHeroEventListFilter;

  constructor(
    public toastService: AppToastManagerService,
    public eventsService: AppEventService,
    public route: ActivatedRoute
  ) {
    super();
  }

  public ngOnInit(): void {
    const { heroEvents, eventCategoryOptions, defaultFilters } = this.route
      .snapshot.data.data as IHeroEventListResolverData;
    this.eventCategoryOptions = eventCategoryOptions;
    this.filters = defaultFilters;
    this.loadData(heroEvents);
  }

  public loadData(
    heroEventsResponse: PaginationResultsDto<HeroEventListResponseDto>
  ): void {
    this.heroEvents = heroEventsResponse.results;
    this.filters.tableFilters.count = heroEventsResponse.options.totalItems;
  }

  public async updateFilters(newFilters: IHeroEventListFilter) {
    this.isLoading = true;
    this.filters = newFilters;
    this.filters.tableFilters = TableFilterOptions.resetTableFilters(
      TableFiltersPageKeyEnum.HERO_EVENT_LIST,
      this.filters.tableFilters
    );
    await this.updateHeroEvents();
  }

  public async updateTableFilters(
    newTableFilters: ITableFilters
  ): Promise<void> {
    this.isLoading = true;
    this.filters.tableFilters = newTableFilters;
    const pageLastIds = this.filters.tableFilters.pageLastIds;
    const page = this.filters.tableFilters.page;
    this.filters.tableFilters.lastId = pageLastIds ? pageLastIds[page] || 0 : 0;
    await this.updateHeroEvents();
  }

  public async updateHeroEvents() {
    this.isLoading = true;
    const result = await this.eventsService.getHeroEvents(this.filters);
    this.loadData(result);
    this.isLoading = false;
  }
}
